<template>
  <div id="section-7" class="section">
    <div v-if="isMaxScreen" class="page pc_page-7">
      <div class="service-container">
        <div class="container">
          <div class="service-left-container">
            <div class="service-content">
              <div class="service-content-title">{{ $t('components.section7.646ns2k5f7k0') }}</div>
              <div class="service-content-sub-title">
                {{ $t('components.section7.646ns2k5gmw0') }}
              </div>
              <div class="service-content-container">
                <div v-for="(item,index) in serviceList" :key="item.name" class="service-content-item">
                  <img :src="item.icon" alt="" class="section-7-image" />
                  <div class="service-content-item-title">{{ item.name }}</div>
                  <div class="service-content-item-text" :class="index == 1 ? 'service-content-item-text2' : ''" v-html="item.text"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="service-right-container">
            <el-form
              class="service-right-form"
              ref="form"
              :model="form"
              :rules="rules"
              label-width="0px"
            >
              <el-form-item class="normal-form-item" label="" prop="customerName">
                <el-input
                  :placeholder="$t('components.section7.646ns2k5gs40')"
                  style="width: 560px"
                  v-model="form.customerName"
                  :maxlength="32"
                >
                </el-input>
              </el-form-item>
              <el-form-item class="select-phone-form-item" label="" prop="mobileNumber">
                <el-input
                  ref="input-mobileNumber"
                  :placeholder="$t('components.section7.646ns2k5gx40')"
                  v-model="form.mobileNumber"
                  style="width: 560px"
                  :maxlength="16"
                  @input="handleInputMoboleNumber('mobileNumber', $event)"
                >
                  <el-select
                    v-model="form.mobileAreaCode"
                    slot="prepend"
                    :popper-append-to-body="false"
                    style="width: 160px"
                  >
                    <img
                      :src="getFlagUrl"
                      alt=""
                      slot="prefix"
                      style="width: 24px; height: 24px; "
                    />
                    <el-option
                      v-for="(item, key) in mobileAreaCode"
                      :key="item.areaCode"
                      :value="item.areaCode"
                    >
                      <div style="display: flex; align-items: center">
                        <img
                          :src="item.flagUrl"
                          alt=""
                          style="width: 24px; height: 24px; margin-right: 10px"
                        />
                        {{ item.areaCode }} {{ item.countryName }}
                      </div>
                    </el-option>
                  </el-select>
                </el-input>
              </el-form-item>

              <!-- <el-form-item :label="$t('PCUserInfo.index.647kboa078s0')" prop="mobile">
                <el-input
                  ref="input-mobileNumber"
                  :placeholder="$t('components.section7.646ns2k5gx40')"
                  v-model="form.mobile"
                  :maxlength="16"
                  @focus="focus"
                >
                  <el-select
                    v-model="form.mobileAreaCode"
                    slot="prepend"
                    :popper-append-to-body="false"
                    style="width: 160px"
                  > 
                    <img :src="getFlagUrl" alt=""  slot="prefix" style="width: 24px; height: 24px; margin-top: 12px;">
                    <el-option
                      v-for="(item, key) in mobileAreaCode"
                      :key="item.areaCode"
                      :value="item.areaCode"
                    >
                      <div style="display: flex; align-items: center; ">
                        <img :src="item.flagUrl" alt="" style="width: 24px; height: 24px; margin-right: 10px;"/>
                        {{ item.areaCode }} {{ item.countryName }}
                      </div>
                    </el-option>
                  </el-select>
                </el-input>
              </el-form-item> -->
              <el-form-item class="normal-form-item" label="" prop="email">
                <el-input
                  :placeholder="$t('components.section7.646ns2k5img0')"
                  style="width: 560px"
                  v-model="form.email"
                  :maxlength="50"
                >
                </el-input>
              </el-form-item>
              <el-form-item class="normal-form-item textarea-form-item" label="" prop="content">
                <el-input
                  type="textarea"
                  :placeholder="$t('components.section7.646ns2k5isw0')"
                  style="width: 560px"
                  :maxlength="500"
                  v-model="form.content"
                ></el-input>
              </el-form-item>
              <el-form-item class="normal-form-item privacy-policy-form-item" label="" prop="">
                <div class="agree-policy-container">
                  <div class="agree-policy-box">
                    <img
                      @click="form.checked = !form.checked"
                      :src="form.checked ? checkedIcon : uncheckedIcon"
                      class="check-icon"
                    />
                    {{ $t('components.section7.646ny1rgz3c0') }}
                  </div>
                  <span @click="handlePolicy" class="policy-text">{{
                    $t('components.section7.646ny1rh2k40')
                  }}</span>
                </div>
              </el-form-item>
              <el-form-item label="" prop="">
                <div class="btn-container">
                  <div class="btn-box" @click="handleSubmitForm">
                    {{ $t('components.section7.646ns2k5iws0') }}
                    <img :src="arrowIcon" class="arrow-icon" />
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="page page-7">
      <div class="service-container">
        <div class="service-left-container">
          <div class="service-content">
            <div class="service-content-title">{{ $t('components.section7.646ns2k5f7k0') }}</div>
            <div class="service-content-sub-title">
              {{ $t('components.section7.646ns2k5gmw0') }}
            </div>
            <div class="service-content-container">
              <div v-for="item in serviceList" :key="item.name" class="service-content-item">
                <img :src="item.icon" alt="" class="section-7-image" />
                <div class="service-content-box">
                  <div class="service-content-item-title">{{ item.name }}</div>
                  <div class="service-content-item-text" v-html="item.text"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="service-right-container">
          <el-form
            class="service-right-form"
            ref="form"
            :model="form"
            :rules="rules"
            label-width="0px"
          >
            <el-form-item class="normal-form-item" label="" prop="customerName">
              <el-input
                :placeholder="$t('components.section7.646ns2k5gs40')"
                v-model="form.customerName"
                :maxlength="32"
              >
              </el-input>
            </el-form-item>
            <el-form-item class="select-phone-form-item" label="" prop="mobileNumber">
              <el-input
                ref="input-mobileNumber"
                :placeholder="$t('components.section7.646ns2k5gx40')"
                v-model="form.mobileNumber"
                :maxlength="16"
                @input="handleInputMoboleNumber('mobileNumber', $event)"
              >
                <!-- <el-select
                  v-model="form.mobileAreaCode"
                  slot="prepend"
                  :popper-append-to-body="false"
                  style="width: 170px"
                >
                  <el-option
                    v-for="(item, key) in mobileAreaCode"
                    :key="key"
                    :value="key"
                    :label="`${item} (${key})`"
                  ></el-option>
                </el-select> -->
                <el-select
                    v-model="form.mobileAreaCode"
                    slot="prepend"
                    :popper-append-to-body="false"
                    style="width: 160px"
                  >
                    <img
                      :src="getFlagUrl"
                      alt=""
                      slot="prefix"
                      style="width: 24px; height: 24px; "
                    />
                    <el-option
                      v-for="(item, key) in mobileAreaCode"
                      :key="item.areaCode"
                      :value="item.areaCode"
                    >
                      <div style="display: flex; align-items: center">
                        <img
                          :src="item.flagUrl"
                          alt=""
                          style="width: 24px; height: 24px; margin-right: 10px"
                        />
                        {{ item.areaCode }} {{ item.countryName }}
                      </div>
                    </el-option>
                  </el-select>
              </el-input>
            </el-form-item>
            <el-form-item class="normal-form-item" label="" prop="email">
              <el-input
                :placeholder="$t('components.section7.646ns2k5img0')"
                v-model="form.email"
                :maxlength="50"
              >
              </el-input>
            </el-form-item>
            <el-form-item class="normal-form-item textarea-form-item" label="" prop="content">
              <el-input
                type="textarea"
                :placeholder="$t('components.section7.646ns2k5isw0')"
                :maxlength="500"
                v-model="form.content"
              ></el-input>
            </el-form-item>
            <el-form-item class="normal-form-item privacy-policy-form-item" label="" prop="checked">
              <div class="agree-policy-container">
                <div class="agree-policy-box">
                  <img
                    @click="form.checked = !form.checked"
                    :src="form.checked ? checkedIcon : uncheckedIcon"
                    class="check-icon"
                  />
                  {{ $t('components.section7.646ny1rgz3c0') }}
                </div>
                <span @click="handlePolicy" class="policy-text">{{
                  $t('components.section7.646ny1rh2k40')
                }}</span>
              </div>
            </el-form-item>
            <el-form-item label="" prop="">
              <div class="btn-container">
                <div class="btn-box" @click="handleSubmitForm">
                  {{ $t('components.section7.646ns2k5iws0') }}
                  <img :src="arrowIcon" class="arrow-icon" />
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getEnumList, contactUs, getMobileAreaCode } from '@/services/api/home';
import { isES } from '@/locales';
export default {
  name: 'section6',
  components: {},
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('components.section7.646ns2k5j140')));
      } else {
        callback();
      }
    };
    const validateEmail = (rule, value, callback) => {
      const emailReg = RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
      if (value === '') {
        callback(new Error(this.$t('components.section7.646ns2k5j4g0')));
      } else if (!emailReg.test(value)) {
        callback(new Error(this.$t('components.section7.646ns2k5j6c0')));
      } else {
        callback();
      }
    };
    return {
      arrowIcon: require('../../../assets/image/eu-home/icon/arrow-right.png'),
      checkedIcon: require('../../../assets/image/eu-home/icon/checked.png'),
      uncheckedIcon: require('../../../assets/image/eu-home/icon/unchecked.png'),
      isChecked: false,
      serviceList: [
        // {
        //   id: 1,
        //   icon: require('../../../assets/image/eu-home/icon/telephone.png'),
        //   name: this.$t('components.section7.646ns2k5j8g0'),
        //   text: '+34 637149195'
        // },
        {
          id: 2,
          icon: require('../../../assets/image/eu-home/icon/shuihao.png'),
          name: `${this.$t('components.section7.646ns2k5jak0')} B19961911`,
          // text: 'Company: 15684873'
          text: ''
        },
        {
          id: 3,
          icon: require('../../../assets/image/eu-home/icon/email.png'),
          name: this.$t('components.section7.646ds2k5j4g0'),
          text: 'support@danghuan.eu'
        },
        {
          id: 4,
          icon: require('../../../assets/image/eu-home/icon/position.png'),
          name: this.$t('components.section7.646ns2k5jck0'),
          text: `${this.$t('components.section7.646ns2s5jck0')}`
        }
      ],
      form: {
        customerName: '',
        mobileAreaCode: '+34',
        mobileNumber: '',
        email: '',
        content: '',
        checked: false
      },
      rules: {
        customerName: [
          {
            required: true,
            message: this.$t('components.section7.646ns2k5jgc0'),
            trigger: 'change'
          }
        ],
        mobileNumber: [{ required: true, validator: validatePhone, trigger: 'change' }],
        email: [{ required: true, validator: validateEmail, trigger: 'change' }],
        content: [
          {
            required: true,
            message: this.$t('components.section7.646ns2k5isw0'),
            trigger: 'change'
          }
        ]
      },
      mobileAreaCode: [],
      isES
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    }),
    isEn() {
      return true;
    },
    getFlagUrl() {
      // form.mobileAreaCode
      let url = '';
      this.mobileAreaCode.forEach(item => {
        if (item.areaCode == this.form.mobileAreaCode) {
          url = item.flagUrl;
        }
      });
      return url;
    }
  },

  created() {
    this.getEnumList();
  },
  methods: {
    getEnumList() {
      getMobileAreaCode().then(res => {
        this.mobileAreaCode = {};
        const { code, data } = res;
        if (code === '0000') {
          this.mobileAreaCode = data;
        }
      });
    },
    handleInputMoboleNumber(prop, value) {
      const text = value?.replace(/\D*/g, '');
      const input = this.$refs[`input-${prop}`].getInput();
      input.value = text;
      this.form[prop] = text;
    },
    handlePolicy() {
      this.$router.push({ name: 'PrivacyPolicy' });
    },
    handleSubmitForm() {
      if (!this.form.checked) {
        this.$toast(this.$t('components.section7.646ns2k5ji40'));
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.form));
          params.customerName = params.customerName.trim();
          delete params.checked;
          contactUs(params).then(res => {
            const { code, data } = res;
            if (code === '0000') {
              this.$toast({
                getContainer: '.service-container',
                type: 'success',
                message: this.$t('components.section7.646ns2k5jk00'),
                icon: require('../../../assets/image/eu-home/icon/successe-icon.png'),
                className: 'toast-container'
              });
              this.form.mobileAreaCode = '+34';
              this.form.checked = false;
              this.resetForm();
            }
          });
        } else {
          Toast.fail(this.$t('components.section7.646ns2k5jm80'));
          return false;
        }
      });
    },
    // getEnumList() {
    //   getEnumList().then(res => {
    //     this.mobileAreaCode = {};
    //     const { code, data } = res;
    //     if (code === '0000') {
    //       this.mobileAreaCode = data.mobileAreaCode;
    //     }
    //   });
    // },
    resetForm() {
      this.$refs.form.resetFields();
    }
  }
};
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  .section {
    .page {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    .pc_page-7 {
      padding: 120px 0 80px;
      width: 100%;
      background: #fff;
      .service-container {
        max-width: 1400px;
        margin: auto;
        .container {
          display: grid;
          column-gap: 3rem;
          grid-template-columns: 4fr 5fr;
          grid-auto-columns: 1fr;
          .service-left-container {
            width: 616px;
            display: flex;
            flex-direction: column;
            .service-content {
              .service-content-title {
                color: #252629;
                font-family: 'PingFang SC';
                font-size: 64px;
                font-style: normal;
                font-weight: 500;
                line-height: 150%;
              }
              .service-content-sub-title {
                color: #8f949d;
                font-family: 'PingFang SC';
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                margin: 10px 0 24px;
              }
              .service-content-container {
                display: flex;
                align-items: flex-start;
                align-content: flex-start;
                row-gap: 48px;
                align-self: stretch;
                flex-wrap: wrap;
                .service-content-item {
                  width: 250px;
                  display: flex;
                  flex-direction: column;
                  flex-shrink: 0;
                  font-family: 'PingFang SC';
                  font-size: 16px;
                  .section-7-image {
                    width: 56px;
                    height: 56px;
                  }
                  .service-content-item-title {
                    margin: 16px 0 8px;
                    color: #252629;
                  }
                  .service-content-item-text {
                    padding-right: 50px;
                    color: #8f949d;
                  }

                  .service-content-item-text2 {
                    padding-right: 50px;
                    color: #252629;
                  }
                }
              }
            }
          }
          .service-right-container {
            max-width: 560px;
            .service-right-form {
              /deep/.el-form-item {
                margin-bottom: 24px;
                &.textarea-form-item,
                &.privacy-policy-form-item {
                  margin-bottom: 14px;
                }
                &.is-error {
                  margin-bottom: 40px;
                }
              }
              /deep/.el-select-dropdown {
                box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.08);
              }
              .normal-form-item {
                /deep/ .el-input__inner {
                  height: 56px;
                  border-radius: 12px;
                  color: #252629;
                  &:focus {
                    border: 1px solid #252629;
                  }
                }
                /deep/ .el-textarea__inner {
                  height: 180px;
                  border-radius: 12px;
                  padding: 16px 24px;
                  font-size: 16px;
                  &:focus {
                    border: 1px solid #252629;
                  }
                }
              }
              /deep/.select-phone-form-item {
                .el-input-group--prepend {
                  .el-input__inner {
                    height: 56px;
                    border-radius: 0 12px 12px 0;
                    color: #252629;
                    &:focus {
                      border-radius: 0 12px 12px 0;
                      border: 1px solid #252629;
                    }
                  }
                  .el-input-group__prepend {
                    border: 0;
                    background: none;
                    .el-input__inner {
                      height: 56px;
                      background: #fff;
                      border-radius: 12px 0 0 12px;
                      border: 1px solid #dcdfe6;
                      border-right: 0;
                      color: #252629;
                      text-align: center;
                      &:focus {
                        height: 56px;
                        border: 1px solid #252629;
                        border-radius: 12px 0 0 12px;
                      }
                    }
                    .el-select-dropdown {
                      width: 560px;
                      left: 0px !important;
                      border-radius: 8px;
                    }
                  }
                }
                &.el-form-item.is-error {
                  .el-input-group--prepend {
                    .el-input__inner {
                      border-color: #f56c6c;
                    }
                  }
                }
              }
              .agree-policy-container {
                display: flex;
                .agree-policy-box {
                  display: flex;
                  align-items: center;
                  gap: 10px;
                  color: #8f949d;
                  font-family: 'PingFang SC';
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 150%;
                  margin-right: 6px;
                  .check-icon {
                    flex-shrink: 0;
                    width: 16px;
                    height: 16px;
                    cursor: pointer;
                  }
                }
                .policy-text {
                  color: #ff9600;
                  font-family: 'PingFang SC';
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  cursor: pointer;
                }
              }
              .btn-container {
                width: 100%;
                display: flex;
                position: relative;
                .btn-box {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 10px;
                  padding: 15px 24px;
                  border-radius: 71px;
                  background: #ff9600;

                  color: #fff;
                  font-family: 'PingFang SC';
                  font-size: 20px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 150%; /* 30px */
                  cursor: pointer;

                  position: absolute;
                  right: 0;

                  .arrow-icon {
                    width: 24px;
                    height: 24px;
                    flex-shrink: 0;
                  }
                }
              }
            }
          }
        }
      }
      /deep/.el-input__prefix{
        display: flex;
        align-items: center;
        
      }
      /deep/.el-input--prefix{
        /deep/.el-input__inner{
          text-align: center;
        }
      }
    }
  }
}
@media (max-width: 980px) {
  .section {
    .page {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .page-7 {
      padding: 120px 30px;
      width: calc(100% - 60px);
      background: #fff;
      .service-container {
        gap: 72px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .service-left-container {
          display: flex;
          flex-direction: column;
          .service-content {
            .service-content-title {
              color: #252629;
              font-family: 'PingFang SC';
              font-size: 56px;
              font-style: normal;
              font-weight: 500;
              line-height: 150%;
            }
            .service-content-sub-title {
              color: #8f949d;
              font-family: 'PingFang SC';
              font-size: 24px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
              margin: 20px 0 64px;
            }
            .service-content-container {
              display: flex;
              flex-direction: column;
              gap: 32px;
              .service-content-item {
                display: flex;
                align-items: center;
                flex-shrink: 0;
                .section-7-image {
                  width: 72px;
                  height: 72px;
                  flex-shrink: 0;
                }
                .service-content-box {
                  margin-left: 16px;
                  .service-content-item-title {
                    color: #252629;
                    font-family: 'PingFang SC';
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 150%;
                  }
                  .service-content-item-text {
                    color: #8f949d;
                    font-family: 'PingFang SC';
                    font-size: 24px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 150%;
                  }
                }
              }
            }
          }
        }
        .service-right-container {
          width: 100%;
          .service-right-form {
            /deep/.el-form-item {
              margin-bottom: 12px;
              &.textarea-form-item,
              &.privacy-policy-form-item {
                margin-bottom: 4px;
              }
              &.is-error {
                margin-bottom: 24px;
              }
            }
            /deep/.el-select-dropdown {
              box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.08);
            }
            /deep/.normal-form-item {
              .el-input__inner {
                height: 48px;
                border-radius: 12px;
                color: #252629;
                &:focus {
                  border: 1px solid #252629;
                }
              }
              .el-textarea__inner {
                height: 100px;
                border-radius: 12px;
                padding: 12px 16px;
                font-size: 14px;
                &:focus {
                  border: 1px solid #252629;
                }
              }
            }
            /deep/.select-phone-form-item {
              .el-input-group--prepend {
                .el-input__inner {
                  height: 48px;
                  border-radius: 0 12px 12px 0;
                  color: #252629;
                  &:focus {
                    border-radius: 0 12px 12px 0;
                    border: 1px solid #252629;
                  }
                }
                .el-input-group__prepend {
                  border: 0;
                  background: none;
                  .el-input__inner {
                    height: 48px;
                    background: #fff;
                    border-radius: 12px 0 0 12px;
                    border: 1px solid #dcdfe6;
                    border-right: 0;
                    color: #252629;
                    text-align: center;
                    &:focus {
                      height: 48px;
                      border: 1px solid #252629;
                      border-radius: 12px 0 0 12px;
                    }
                  }
                  .el-select-dropdown {
                    width: calc(100vw - 0.8rem);
                    left: 0px !important;
                    border-radius: 8px;
                  }
                }
              }
              &.el-form-item.is-error .el-input-group--prepend .el-input__inner {
                border-color: #f56c6c;
              }
            }

            .agree-policy-container {
              display: flex;
              .agree-policy-box {
                display: flex;
                align-items: center;
                margin-right: 8px;
                color: #8f949d;
                font-family: 'PingFang SC';
                font-size: 28px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                .check-icon {
                  flex-shrink: 0;
                  width: 32px;
                  height: 32px;
                  margin-right: 20px;
                  cursor: pointer;
                }
              }
              .policy-text {
                color: #ff9600;
                font-family: 'PingFang SC';
                font-size: 28px;
                font-style: normal;
                font-weight: 400;
                cursor: pointer;
              }
            }
            .btn-container {
              width: 100%;
              display: flex;
              position: relative;
              .btn-box {
                display: flex;
                justify-content: center;
                align-items: center;

                gap: 12px;
                padding: 20px 40px;
                border-radius: 71px;
                background: #ff9600;

                color: #fff;
                font-family: 'PingFang SC';
                font-size: 28px;
                font-style: normal;
                font-weight: 500;
                line-height: 150%;
                cursor: pointer;

                position: absolute;
                right: 0;

                .arrow-icon {
                  width: 32px;
                  height: 32px;
                  flex-shrink: 0;
                }
              }
            }
          }
        }
      }
      /deep/.el-input__prefix{
        display: flex;
        align-items: center;
        
      }
      /deep/.el-input--prefix{
        /deep/.el-input__inner{
          text-align: center;
        }
      }
    }
  }
}

/deep/.el-select-dropdown__item {
  &:hover,
  &.selected {
    background: #ff9600;
    color: #fff;
    font-weight: 700;
  }
}
/deep/.van-toast.toast-container {
  padding: 16px 12px;
  min-height: 50px;
  width: 100px;
  word-break: break-word;
  .van-toast__icon {
    font-size: 32px !important;
    img {
      width: 32px !important;
    }
  }
}
</style>
